import { lightBlue } from '@material-ui/core/colors'

const styles = (theme) => ({
  internationalTransferField: {
    backgroundColor: lightBlue[50],
    borderRadius: theme.spacing(0.5),
  },
  inputBackground: {
    backgroundColor: theme.palette.white,
  },
  multiSelect: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.secondary,
  },
})

export default styles
